// Un-Comment Console.logs for debugging if needed

import { EventType, PublicClientApplication } from '@azure/msal-browser';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';
import { msalAuthConfig } from './Utils/msalAuthConfig';
import { getCspNonce } from './Utils/cspNonce';

// Get CSP nonce from meta tag
const nonce = getCspNonce();

// console.log('=== CSP NONCE DEBUG ===');
// console.log('Nonce value:', nonce);
// console.log('Nonce type:', typeof nonce);
// console.log('Nonce length:', nonce?.length);
// console.log('Is empty?', nonce === '');
// console.log('Is undefined?', nonce === undefined);

if (!nonce || nonce === '') {
  console.error(' CSP Nonce not found or empty in meta tag!');
  // console.error('Available meta tags:', document.querySelectorAll('meta'));
} else {
  // console.log(' Valid nonce found:', nonce);
}

// Set global nonce for Webpack to use
if (nonce && nonce !== '') {
  // @ts-ignore - __webpack_nonce__ is a global variable used by Webpack
  __webpack_nonce__ = nonce;
  // console.log(' Set global __webpack_nonce__:', nonce);
}

// Create Emotion cache with nonce for CSS-in-JS
// Only pass nonce if it's a valid non-empty string
const emotionCache = createCache({
  key: 'css',
  nonce: nonce && nonce !== '' ? nonce : undefined,
  prepend: true,
});

// console.log(' Created Emotion cache');
// console.log('   Cache nonce:', emotionCache.sheet.nonce);
// console.log('   Cache key:', emotionCache.key);

const msalInstance: any = new PublicClientApplication(msalAuthConfig);

msalInstance.addEventCallback((event: any) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <CacheProvider value={emotionCache}>
      <App msalInstance={msalInstance} />
    </CacheProvider>
  </React.StrictMode>,
);
